import React, { useState, useEffect } from "react";
import $ from "jquery";
import dompurify from 'dompurify';
import TasksCKEditorLink from "../../../../../components/NewActivityDetailsPage/TasksCKEditorLink";


const TaskMyContributions = ({
	taskData,
	toolsSidebarHeight,
	taskSuggestions,
	ckEditorUserMap,
	reviewedTaskSuggestions,
	pagetypecalling
}) => {
	const getReviewStatus = (task, cardclass) => {
		if (reviewedTaskSuggestions.length > 0) {
			const status = JSON.parse(
				reviewedTaskSuggestions.filter(
					(item) => JSON.parse(item).id === task.id
				)[0]
			).state;
			if (cardclass) {
				if (status === "accepted") {
					return "Approved";
				} else {
					return "Rejected";
				}
			} else {
				return status;
			}
		}
		return null;
	};

	const htmlSanitizer = (data) => {
		const config = {
			ADD_ATTR: ['target'],
		};
		return dompurify.sanitize(data, config);
	};

	function removePTags(html) {
		// Replace all <p> tags with an empty string
		return html.replace(/<p>/g, '').replace(/<\/p>/g, '');
	}

	return (
		<>
			<div className="customToolsEditor" style={{minHeight:'auto',height:'auto'}}>
				<div className={pagetypecalling === "mycontribution" ? "toolsEditorMainContainer ToolsIDClass border-0 mt-0  pr-2" : "toolsEditorMainContainer"} style={{ maxWidth: pagetypecalling === 'mycontribution' ? 'calc(100% - 290px)' : '',minHeight:'auto' }}>
					<div className="TaskIDAct">
						<div class="criteria-history-tab-container">

							<div>
								
							<div className="addPolygonTopicRelatedInputContainer">
    <div className="polygonInputContainer">
        {(() => {
            const dataToRender = [...taskData, ...taskSuggestions.map(JSON.parse)];
            const uniqueDataToRender = dataToRender.reduce((acc, item) => {
                const existingIndex = acc.findIndex(t => t.id === item.id);
                if (existingIndex === -1) {
                    acc.push(item);
                } else if (taskSuggestions.some(suggestion => JSON.parse(suggestion).id === item.id)) {
                    acc[existingIndex] = item; // Replace with taskSuggestions item
                }
                return acc;
            }, []);

            return uniqueDataToRender.length > 0 ? (
                uniqueDataToRender.map((parsedItem, index) => {
                    const isLastTask = parsedItem.id === uniqueDataToRender[uniqueDataToRender.length - 1].id;

                    return (
                        <div
                            className={`row taskmaincontainer ${parsedItem.suggestionType === "deletion" ? "userDeletedCriteria" : "userAddedCriteria"}`}
                            key={parsedItem.id || index}
                            style={{ display: "flex", alignItems: "stretch" }}
                        >
                            <div className="col-xl-11 col-lg-11 pl-0 pr-2 ckdivtasks TaskWidth_latest">
                                <TasksCKEditorLink
                                    value={parsedItem.name || ""}
                                    pageType="editactivityfromcontro"
                                    readonly={true}
                                />
                            </div>
                            <div className="ckdivtasksicon align-bottom">
                                <button className="disableIconsCross relatededitContentDelete TaskLatest_Button" disabled />
                                {isLastTask && (
                                    <button
                                        className="disableIconsAdd relatedContentAdd AddEntryBtnLatest"
                                        disabled = {true}
                                        onKeyPress={(e) => {
                                            if (e.which === 13) {
                                                // handleAddBusinessContentFields();
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })
            ) : (
                <> </>
            );
        })()}
    </div>
</div>




							</div>
						</div>
					</div>
				</div>
				{/* <div className="" style={{ height: toolsSidebarHeight }}> */}
				<div
					style={{ height: toolsSidebarHeight }}
					className='toolsSidebar toolsSidebar_latest pt-0'
				>
					{taskSuggestions.map(
						(card) => (
							(
								<>
									<div
										className={`sideBarCard sideBarCardLatest_Entry ${JSON.parse(card).suggestionType === 'deletion'
												? 'userDeletedToolsAndGuidance'
												: 'userAddedItem'
											} ${getReviewStatus(JSON.parse(card), false)}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className="nonCkEditorAuthor">{ckEditorUserMap[JSON.parse(card).authorId][0]}</span>
											<span className="suggestionStatus suggestionStatusLatest myContributionSuggestionStatus">
												{getReviewStatus(JSON.parse(card), true)}
											</span>
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'deletion'
													? 'Remove'
													: JSON.parse(card).suggestionType === 'insertion'
														? 'Add'
														: 'Edit'}
											</span>
											&nbsp;"Description:<div dangerouslySetInnerHTML={{ __html: htmlSanitizer(removePTags(JSON.parse(card).name)) }} />
										</div>
									</div>
								</>
							)))}
				</div>
				{/* </div> */}
			</div>
		</>
	);
};

export default TaskMyContributions;
